import { lazy } from 'react';

/* Code-split every route into its own chunk. The Home page hero is
 * lightweight (no Three.js once the EarthScene is lazy-loaded), but
 * the game pages pull in Three.js, react-three-fiber, drei, turf, and
 * Google Maps libs that would otherwise sit in the main bundle and
 * destroy initial-load performance. */
const Home              = lazy(() => import('../pages/Home/Home'));
const Stats             = lazy(() => import('../pages/Stats/Stats'));
const Game              = lazy(() => import('../pages/Game/Game'));
const HuntGame          = lazy(() => import('../pages/Hunt/HuntGame'));
const PhotoGame         = lazy(() => import('../pages/Photo/PhotoGame'));
const PangaeaGame       = lazy(() => import('../pages/Pangaea/PangaeaGame'));
const LandmarkGame      = lazy(() => import('../pages/Landmark/LandmarkGame'));
const SpotLandmarkGame  = lazy(() => import('../pages/SpotLandmark/SpotLandmarkGame'));
const AudioAtlasGame    = lazy(() => import('../pages/AudioAtlas/AudioAtlasGame'));
const AuthCallback      = lazy(() => import('../pages/AuthCallback/AuthCallback'));
const AdminPage         = lazy(() => import('../pages/Admin/AdminPage'));
const ProfilePage       = lazy(() => import('../pages/Profile/ProfilePage'));
const About             = lazy(() => import('../pages/Legal/About'));
const Privacy           = lazy(() => import('../pages/Legal/Privacy'));
const Terms             = lazy(() => import('../pages/Legal/Terms'));
const Cookies           = lazy(() => import('../pages/Legal/Cookies'));
const RulesPage         = lazy(() => import('../pages/Rules/RulesPage'));

/**
 * Live games:
 *  - /game/origin   → Origin Hunt     (5-level Street View guessing)
 *  - /game/hunt     → Object Hunt     (POI GPS treasure hunt, L1)
 *  - /game/photo    → Photo Detective (5-level observation/deduction, Premium)
 *  - /game/pangaea  → Pangaea Puzzle  (place 6 continents on a 3D Earth, 5 levels)
 *  - /game/landmark → Landmark Quiz   (Wikipedia photo → world-map pin, free)
 *
 * Legal/static pages: /about, /privacy, /terms, /cookies
 */
export const routes = [
  { path: '/',             element: () => <Home /> },
  { path: '/stats',        element: () => <Stats /> },

  // Per-game rules / "how to play" landing pages — Home cards link here.
  { path: '/game/:gameId/rules', element: () => <RulesPage /> },

  { path: '/game/origin',   element: () => <Game /> },
  { path: '/game/hunt',     element: () => <HuntGame /> },
  { path: '/game/photo',    element: () => <PhotoGame /> },
  { path: '/game/pangaea',  element: () => <PangaeaGame /> },
  { path: '/game/landmark', element: () => <LandmarkGame /> },
  { path: '/game/spot',     element: () => <SpotLandmarkGame /> },
  { path: '/game/audio',    element: () => <AudioAtlasGame /> },

  { path: '/auth/callback', element: () => <AuthCallback /> },
  { path: '/admin',         element: () => <AdminPage /> },
  { path: '/profile',       element: () => <ProfilePage /> },

  { path: '/about',        element: () => <About /> },
  { path: '/privacy',      element: () => <Privacy /> },
  { path: '/terms',        element: () => <Terms /> },
  { path: '/cookies',      element: () => <Cookies /> },

  // Legacy fallback
  { path: '/game', element: () => <Game /> },
];
